// extracted by mini-css-extract-plugin
export default {"removePadding":"SvgIcon-module--removePadding--67ef7"};